'use strict';

wbApp.directive('wbSecurityRoleCombo', ['$timeout', 'userRolesSvc',
    function ($timeout, userRolesSvc) {
        function formatResult(data) {
            if (!data) { return; }

                return "<div class='row' style='width:100%'>" +
                           "<div class='col-md-3'>" + data.name + "</div>" +
                           "<div class='col-md-9'>" + (data.description || '') + "</div>" +
                       "</div>";
        }

        function formatSelection(data) {
            return data.name;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                ngModel: '=',
                ngChange: '&'
            },
            template: "<input class='select2' style='width: 100%;' />",
            link: function (scope, elm, attrs, controller) {

                var roles = userRolesSvc.getAllAsync();

                $timeout(function () {
                    $(elm).select2({
                        //placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_SEMESTER'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: roles
                    });
                    controller.$render();

                    scope.$watch('ngModel', function (newValue) {
                        if (newValue) {
                            roles.$promise.then(function () {
                                $(elm).select2('val', newValue);
                            });
                        }
                    });

                    $(elm).on("change", function (e) {
                        if (scope.ngChange()) {
                            scope.ngChange()(e.added);
                        }
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    if (attrs.ngEnable) {
                        scope.$watch(attrs.ngEnable, function (newVal) {
                            elm.select2('enable', !!newVal);
                        });
                    }

                }, 1);
            }
        }
    }]);    